import Vue from 'vue'

/**
 * Clears every toast on the page, for when the session ends: nothing from the
 * old session belongs on the login screen, and some toasts never close on
 * their own (duration: 0).
 *
 * notification.destroy() alone is not enough. ant-design-vue 1.x creates its
 * toast container on the next tick and caches one per corner, so two toasts
 * opened in the same tick before a container exists get a container each, the
 * cache keeps only the second, and destroy() never reaches the first (seen on
 * 1.7.8). Whatever is left after destroy() is such an orphan, so it is removed
 * from the page directly.
 */
export default function clearAllToasts() {
  Vue.prototype.$notification.destroy()
  Vue.prototype.$message.destroy()
  document.querySelectorAll('.ant-notification, .ant-message').forEach((el) => el.remove())
}
